function handleCollectionTagFilter() {

    jQuery('.sm--collection-filter').on('change', function () {

        var $el = jQuery(this).children("option:selected");

        window.location.href = $el.data('url');

    });

}

function updateColorName() {

    var $colorNameContainer = jQuery('.sm--product-current-color-wrapper .sm--variant-color');

    jQuery('.webyzeSwatches').on('click', '.swatchColor', function () {

        var $el = jQuery(this);

        var text = $el.data('name');
        if (text === 'DC-A - Cola') {
            text += '<br> Coarse texture'
            jQuery('.sm--african-explanation').show();
        } else {
            jQuery('.sm--african-explanation').hide();
        }

        $colorNameContainer.html(text);

    });

}

function bindProductImagesClick() {

    jQuery('.product__thumbs').on('click', '.product__thumb-item', function () {

        var $el = jQuery(this);
        var color = $el.find('.product__thumb').data('color');

        jQuery('.webyzeSwatches').find('.swatchColor[data-name="' + color + '"]').click();

    });

}

function bindCartWaveSignature() {

    var $checkbox = jQuery('#WaveSignature');
    var $giveaway_checkbox = jQuery('#Giveaway');
    var $order_note = jQuery('#CartSpecialInstructions');
    var customerData = window.customerData;

    $checkbox.on('change', function () {

        // Get the giveaway checkbox
        // var addition = '';
        // if($giveaway_checkbox.is(":checked")) {
        //     addition = '<br>I want to enroll in the giveaway.';
        // }
        //
        // if(this.checked) {
        //     $order_note.text('I want to wave the delivery signature of my order.' + addition);
        // } else {
        //     $order_note.text(addition);
        // }

        if (this.checked) {
            // Set a cookie
            setCookie('wave_signature', 'yes', 365);
            localStorage.setItem('wave_signature', 'yes');
            fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({customer: customerData}),
            })
            $order_note.text('I want to wave the delivery signature of my order.');

            fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ note: 'I want to wave the delivery signature of my order.' })
            })
            .then(response => response.json())
            .then(data => console.log(data));
        } else {
            setCookie('wave_signature', 'no', 365);
            localStorage.setItem('wave_signature', 'no');
            fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({customer: customerData}),
            })
            $order_note.text('');

            fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ note: '' })
            })
            .then(response => response.json())
            .then(data => console.log(data));
        }

    });

}

function bindCartWaveSignatureCheck() {

    var $checkbox = jQuery('#WaveSignature');
    var $order_note = jQuery('#CartSpecialInstructions');
    var customerData = window.customerData;

    if ($checkbox.is(":checked")) {
        setCookie('wave_signature', 'yes', 365);
        localStorage.setItem('wave_signature', 'yes');
        fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({customer: customerData}),
        })
        $order_note.text('I want to wave the delivery signature of my order.');

        fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: 'I want to wave the delivery signature of my order.' })
        })
        .then(response => response.json())
        .then(data => console.log(data));
    } else {
        setCookie('wave_signature', 'no', 365);
        localStorage.setItem('wave_signature', 'no');
        fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({customer: customerData}),
        })
        $order_note.text('');
            
        fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: '' })
        })
        .then(response => response.json())
        .then(data => console.log(data));
    }

}

function bindRegularCartWaveSignature() {

    var $checkbox = jQuery('#WaveRegularSignature');
    var $order_note = jQuery('#CartRegularSpecialInstructions');
    var customerData = window.customerData;
    $checkbox.on('change', function () {

        if (this.checked) {
            // Set a cookie
            setCookie('wave_signature', 'yes', 365);
            localStorage.setItem('wave_signature', 'yes');
            fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({customer: customerData}),
            })
            $order_note.text('I want to wave the delivery signature of my order.');

            fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ note: 'I want to wave the delivery signature of my order.' })
            })
            .then(response => response.json())
            .then(data => console.log(data));
        } else {
            setCookie('wave_signature', 'no', 365);
            localStorage.setItem('wave_signature', 'no');
            fetch('https://dc-api-1m1j.onrender.com/api/dc/customers/toggle/waive-signature', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({customer: customerData}),
            })
            $order_note.text('');
            
            fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ note: '' })
            })
            .then(response => response.json())
            .then(data => console.log(data));
        }

    });

}

function bindCartGiveawayEnrol() {

    var $checkbox = jQuery('#Giveaway');
    var $wave_checkbox = jQuery('#WaveSignature');
    var $order_note = jQuery('#CartSpecialInstructions');
    var customerData = window.customerData;

    $checkbox.on('change', function () {

        // Get the giveaway checkbox
        var addition = '';
        if ($wave_checkbox.is(":checked")) {
            addition = '<br>I want to wave the delivery signature of my order.';
        }

        if (this.checked) {
            $order_note.text('I want to enroll in the giveaway.' + addition);
        } else {
            $order_note.text(addition);
        }

    });

}

function hiddenColors(hide = false, style_override = false) {

    var hidden_colors = {};

    hidden_colors['Straight'] = [
        'DC-A',
        'DC-P1',
        'DC-P2',
        'DC-R',
        'DC-B',
        'OM-K',
        'OM-RED',
        'DC-PC',
        'DC-PK',
        'DC-L',
        'DC-M',
        'DC-SLVR',
        'DC-6/19A',
        'DC-BL7/9A',
        'DC-BL8/12',
        'DC-R2/7A',
        'DC-R6/20A',
        'DC-S1/3',
    ];

    hidden_colors['Wavy'] = [
        'DC-A',
        'OM-K',
        'OM-RED',
        'DC-6/19A',
        'DC-BL7/9A',
        'DC-BL8/12',
        'DC-R2/7A',
        'DC-R6/20A',
        'DC-S1/3',
    ];

    hidden_colors['Medium Curl'] = [
        'DC-A'
    ];

    hidden_colors['Tight Curl'] = [
        'DC-A'
    ];

    if (!style_override) {
        var style = jQuery('input[name="Style"]:checked').val();
    } else {
        var style = style_override;
    }

    var product_id = jQuery('[id^=ProductSection-]').data('section-id');
    var $swatch_container = jQuery('#webyzeSwatches_swatcher');

    if (product_id == 6772685176982 || product_id == 6772692385942 || product_id == 6772698415254 || product_id == 6772704608406 || product_id == 8175867855094) {

        if (hide) {
            ;

            $swatch_container.find('span.swatchColor').each(function (index, element) {

                var color = jQuery(element).data('color-name');

                if ($.inArray(color, hidden_colors[style]) > -1) {
                    jQuery(element).addClass('hiddenColor');
                    jQuery(element).attr('style', 'display: none !important');
                }

            });

        } else {

            $swatch_container.find('span.swatchColor').each(function (index, element) {

                var color = jQuery(element).data('color-name');

                if ($.inArray(color, hidden_colors[style]) > -1) {
                    jQuery(element).removeClass('hiddenColor');
                    jQuery(element).attr('style', 'display: inline-flex !important');
                }

            });

        }

    }

}

function bindProductSizeChange() {

    jQuery('.sm--variant-type-Size').on('click', 'label', function () {

        var $el = jQuery(this);
        var $weight_container = jQuery('.sm--product-features-list .sm--feature-weight').find('.sm--feature-value');

        if ($el.attr('for').indexOf('size-Full') != -1) {

            hiddenColors(false);
            $weight_container.html('0.8g per strand (20g total)');

        } else {

            hiddenColors(true);
            $weight_container.html('15 Grams');

        }

        if (jQuery('span.swatchColor.currentSwatch').is(":hidden") || jQuery('span.swatchColor.currentSwatch').length <= 0) {
            jQuery('span.swatchColor:not(.unavailable)').first().click();
        }

    });

}

// Method will add the course to the cart
function bindAddCourseButton() {

    jQuery('.sm--add-course-button').not('.weft-course').not('.hands-on-training').on('click', function () {

        if (__st.cid === undefined) {

            CartJS.addItem(42038256468214, 1, {}, {
                "success": function (data, textStatus, jqXHR) {
                    // window.location.href = '/account/register';
                    return false;
                }
            });

        } else {

            CartJS.addItem(42038256468214, 1, {}, {
                "success": function (data, textStatus, jqXHR) {
                    // window.location.href = '/checkout';
                    return false;
                }
            });

        }

    });

    jQuery('.sm--add-course-button.weft-course').not('.hands-on-training').on('click', function () {

        if (__st.cid === undefined) {

            CartJS.addItem(42039034118390, 1, {}, {
                "success": function (data, textStatus, jqXHR) {
                    // window.location.href = '/account/register';
                    return false;
                }
            });

        } else {

            CartJS.addItem(42039034118390, 1, {}, {
                "success": function (data, textStatus, jqXHR) {
                    // window.location.href = '/checkout';
                    return false;
                }
            });

        }

    });

    jQuery('.sm--add-course-button-4-in-1').on('click', function () {

        if (__st.cid === undefined) {

            CartJS.addItem(44975724691702, 1, {}, {
                "success": function (data, textStatus, jqXHR) {
                    // window.location.href = '/account/register';
                    return false;
                }
            });

        } else {

            CartJS.addItem(44975724691702, 1, {}, {
                "success": function (data, textStatus, jqXHR) {
                    // window.location.href = '/checkout';
                    return false;
                }
            });

        }

    });

    jQuery('.sm--add-course-button-4-in-1.remove-click-event').off('click');

    // jQuery('.both-trainings').not('.weft-course').on('click', function() {
    //
    //     if(__st.cid === undefined) {
    //
    //         CartJS.addItem(40314164871318, 1, {}, {
    //             "success": function(data, textStatus, jqXHR) {
    //                 setTimeout(function () {
    //                     window.location.href = '/collections/hands-on-trainings';
    //                 }, 1000);
    //                 return false;
    //             }
    //         });
    //
    //     } else {
    //
    //         CartJS.addItem(40314164871318, 1, {}, {
    //             "success": function(data, textStatus, jqXHR) {
    //                 setTimeout(function () {
    //                     window.location.href = '/collections/hands-on-trainings';
    //                 }, 1000);
    //                 return false;
    //             }
    //         });
    //
    //     }
    //
    // });
    //
    // jQuery('.both-trainings.weft-course').on('click', function() {
    //
    //     if(__st.cid === undefined) {
    //
    //         CartJS.addItem(40314164871318, 1, {}, {
    //             "success": function(data, textStatus, jqXHR) {
    //                 setTimeout(function () {
    //                     window.location.href = '/collections/hands-on-trainings';
    //                 }, 1000);
    //                 // window.location.href = '/account/register';
    //                 return false;
    //             }
    //         });
    //
    //     } else {
    //
    //         CartJS.addItem(40314164871318, 1, {}, {
    //             "success": function(data, textStatus, jqXHR) {
    //                 setTimeout(function () {
    //                     window.location.href = '/collections/hands-on-trainings';
    //                 }, 1000);
    //                 return false;
    //             }
    //         });
    //
    //     }
    //
    // });

}

// Invoking all functions and methods
jQuery(function () {

    //var $el, leftPos, newWidth, $mainNav = jQuery(".tabs");
    //$mainNav.append("<li id='magic-line'></li>");
    //var $magicLine = jQuery("#magic-line");
    //var $homeTabs = jQuery(".tabs li");
    //$homeTabs.on('click', function() {
    //    $el = jQuery(this);
    //    $magicLine.width($el.width())
    //        .css("left", $el.position().left + 15)
    //        .data("origLeft", $magicLine.position().left + 15)
    //        .data("origWidth", $magicLine.width());
    //});
    //$magicLine.width(jQuery(".current").width())
    //        .css("left", jQuery(".current").position().left + 15)
    //        .data("origLeft", $magicLine.position().left + 15)
    //        .data("origWidth", $magicLine.width());
    //$homeTabs.hover(function() {
    //    $el = jQuery(this);
    //    leftPos = $el.position().left + 15;
    //    newWidth = $el.width();
    //    $magicLine.stop().animate({
    //        left: leftPos,
    //        width: newWidth
    //    }, 300);
    //}, function() {
    //    $magicLine.stop().animate({
    //        left: $magicLine.data("origLeft"),
    //        width: $magicLine.data("origWidth")
    //    }, 300);
    //});

    // Color swatch names
    updateColorName();

    // Product images click to change the selected color
    bindProductImagesClick();

    // Bind the Size change of the I-tip 20 product
    bindProductSizeChange();

    // Bind the add course to cart button
    bindAddCourseButton();

    // Bind collection tag filter
    handleCollectionTagFilter();

});

jQuery(window).on('load', function () {

    // Bind the wave signature checkbox in the cart
    bindCartWaveSignature();
    bindRegularCartWaveSignature();
    bindCartGiveawayEnrol();

    // Make an additional check 2 seconds later if the user had clicked the wave signature BEFORE the page load
    // setTimeout(() => {
    //
    //     var $checkbox = jQuery('#WaveSignature');
    //     var $order_note = jQuery('#CartSpecialInstructions');
    //
    //     if($checkbox.is(":checked")) {
    //         setCookie('wave_signature', 'yes', 365);
    //         $order_note.text('I want to wave the delivery signature of my order.');
    //     } else {
    //         setCookie('wave_signature', 'no', 365);
    //         $order_note.text('');
    //     }
    //
    // }, 2000);


    // Checkbox 'hack' for the wave signature
    // setInterval(function () {
    //     console.log('checking');
    //     bindCartWaveSignatureCheck();
    // }, 1000);

});


// stf.markov 07.07.20
function handleAnchors(section) {
    jQuery(section + " a[href^='#']").on('click', function (e) {
        e.preventDefault();
        var sectionId = jQuery(this).attr('href');
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(sectionId).offset().top - 100
        }, 1000);
    })
}

handleAnchors('.article__body');

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.clp-play').forEach(function (el) {
        el.addEventListener('click', function () {
            el.classList.add('hide');
        });
    });
});